var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
import { inject } from "tsyringe";
import { IdMap, RArray } from "../../collections";
import { perRestaurant } from "../../di";
import { ExtraFeeTypes } from "../Menu";
import { PackagingFeeInstance } from "./PackagingFeeInstance";
import { makeImmutable } from "../../core";
let PackagingFeeInstanceFactory = class PackagingFeeInstanceFactory {
    constructor(extraFeeTypes) {
        this.extraFeeTypes = extraFeeTypes;
        makeImmutable(this);
    }
    create({ orderLineIndex, orderLine: { productInstance, quantity: orderLineQuantity }, }) {
        const productInstanceResult = productInstance.productPackagingFeeId === null
            ? RArray.empty()
            : RArray.singleton(new PackagingFeeInstance({
                packagingFeeType: this.extraFeeTypes.get(productInstance.productPackagingFeeId),
                orderLineIndex,
                subject: { type: "ProductType" },
                quantity: orderLineQuantity,
            }));
        const modifierResults = productInstance.modifierInstances.flatMap((modifierInstance) => modifierInstance.selectedItems.mapOptional(({ modifierItemType: { id: modifierItemTypeId }, modifierItemPackagingFeeId, quantity: modifierItemQuantity, }) => {
            if (modifierItemPackagingFeeId === null) {
                return null;
            }
            return new PackagingFeeInstance({
                packagingFeeType: this.extraFeeTypes.get(modifierItemPackagingFeeId),
                orderLineIndex,
                subject: { type: "ModifierItem", modifierItemTypeId },
                quantity: orderLineQuantity.mul(modifierItemQuantity),
            });
        }));
        return productInstanceResult.concatenated(modifierResults);
    }
};
PackagingFeeInstanceFactory = __decorate([
    perRestaurant(),
    __param(0, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof IdMap !== "undefined" && IdMap) === "function" ? _a : Object])
], PackagingFeeInstanceFactory);
export { PackagingFeeInstanceFactory };
